export const actionTypes = {
  LOAD_NEXT_PROJECTED_ORDER: 'LOAD_NEXT_PROJECTED_ORDER',
  MY_GOUSTO_LOAD_ORDERS: 'MY_GOUSTO_LOAD_ORDERS',
}
